import type { FunctionComponent } from 'react';
import cx from 'classnames';
import type { PerksList } from '@fff-web/fff-ui-shared';
import { getImagesStaticUrl } from '../../helpers';
import { useUpgradeMembershipContext } from '../../utils/ContextProviders/UpgradeContext';

type PlanOptionsProps = {
  perks: PerksList;
  plan: keyof PerksList[number]['check'];
};

const PlanOptions: FunctionComponent<PlanOptionsProps> = ({ perks, plan }) => (
  <ul className="planOptions">
    {perks.map(({ label, check, boldText }) => (
      <li key={label} className={cx({ strikeThrough: !check?.[plan] })}>
        <i
          className={cx(
            'far',
            { 'fa-times': !check?.[plan] },
            { timesIcon: !check?.[plan] },
            { checkIcon: check?.[plan] },
            { 'fa-check': check?.[plan] },
          )}
        />
        <span>
          {label}
          {boldText !== '' && ' '}
          {boldText !== '' && <b>{boldText}</b>}
        </span>
      </li>
    ))}
  </ul>
);

type DesktopCardsProps = {
  getCouponContentKey: (key: string, defaultValue: string) => string;
};

const DesktopCards: FunctionComponent<DesktopCardsProps> = ({ getCouponContentKey }) => {
  const { growthUpgrade } = useUpgradeMembershipContext();
  const { variables } = growthUpgrade;
  const perks = variables.perks?.list ?? [];
  const seasonalPlans = variables.plans?.seasonal ?? {};
  const annualPlan = variables.plans?.annual ?? {};

  const seasonalPerksList = perks.filter((perk) => !perk.skip.seasonal);
  const annualPerksList = perks.filter((perk) => !perk.skip.annual);
  return (
    <div className="upgradePlansContainer mobile-hidden" data-testid="upgradePlansContainer">
      <div className="seasonalPlanContainer">
        <header className="planTitle planTitle__seasonal">{seasonalPlans.heading}</header>
        <span className="planSubtitleMd">{seasonalPlans.subheading}</span>
        <span className="planSubtitle currentPlan" style={{ display: 'block' }}>
          {getCouponContentKey('seasonalPlan.note', 'Current Plan')}
        </span>
        <hr />
        <PlanOptions perks={seasonalPerksList} plan="seasonal" />
      </div>
      <div className="annualPlanContainer ">
        <div style={{ position: 'relative' }}>
          <img
            className="bestValueDesktop"
            src={getImagesStaticUrl('best-value-desktop.svg')}
            alt="best value"
          />
          <header className="planTitle">{annualPlan.heading}</header>
        </div>
        <span className="planSubtitle">{annualPlan.subheading}</span>
        <hr />
        <PlanOptions perks={annualPerksList} plan="annual" />
      </div>
    </div>
  );
};

export default DesktopCards;
